import {createSelector} from "@reduxjs/toolkit";
import {biomarkersDataSelector} from "./biomarkersSlice";
import {isEmpty} from "es-toolkit/compat";

export const selectBiomarkersData = createSelector([biomarkersDataSelector], biomarkers =>
  !isEmpty(biomarkers) ? biomarkers : [],
);
